import React, { createContext, useContext } from "react";
import HyroTable from "@hyro-components/hyro-table/HyroTable";
import {
  BENCHMARK_TYPES,
  VALUE_REFERENCES_TABLE_COLUMNS,
  VALUE_REFERENCE_MAX,
  VALUE_REFERENCE_VALIDATION_ERROR
} from "./AnalyticsSettings.consts";
import { getOverrideTypeColumn } from "./AnalyticsSettings.utils";
import EditableMetricCell from "./EditableMetricCell";

const ValueReferenceUpdateContext = createContext(null);

const formatDollars = (value) => `$${Number(value).toLocaleString()}`;

const ValueReferenceEditCell = (params) => {
  const onValueReferenceUpdate = useContext(ValueReferenceUpdateContext);
  return (
    <EditableMetricCell
      {...params}
      max={VALUE_REFERENCE_MAX}
      errorMessage={VALUE_REFERENCE_VALIDATION_ERROR}
      helperText={`Default ${formatDollars(params.row.defaultValue)}`}
      onCommit={(num) => onValueReferenceUpdate(params.row.id, num)}
    />
  );
};

const valueColumn = {
  ...VALUE_REFERENCES_TABLE_COLUMNS[1],
  editable: true,
  renderEditCell: (params) => <ValueReferenceEditCell {...params} />,
  renderCell: ({ value }) => formatDollars(value)
};

const typeColumn = getOverrideTypeColumn(VALUE_REFERENCES_TABLE_COLUMNS[2]);

const columns = [VALUE_REFERENCES_TABLE_COLUMNS[0], valueColumn, typeColumn];

const formatRows = (valueReferences) =>
  valueReferences.map((v) => ({
    id: v.referenceId,
    metricName: v.referenceName,
    value: v.value,
    defaultValue: v.defaultValue,
    type: v.isOverridden ? BENCHMARK_TYPES.CUSTOM : BENCHMARK_TYPES.DEFAULT,
    isOverridden: v.isOverridden
  }));

const ValueReferencesTable = ({ valueReferences, loading, onValueReferenceUpdate }) => {
  const rows = valueReferences ? formatRows(valueReferences) : [];

  return (
    <ValueReferenceUpdateContext.Provider value={onValueReferenceUpdate}>
      <HyroTable
        columns={columns}
        rows={rows}
        loading={loading}
        disableColumnSorting
        testId="value-references"
        minHeight={1}
        dataGridProps={{ autoHeight: true }}
      />
    </ValueReferenceUpdateContext.Provider>
  );
};

export default ValueReferencesTable;
